import DragAdapterInterface from '../interfaces/adapters'
import StyleObject from '../utils/styleobject'
import { Position } from '@/interfaces/general'
import BaseAdapter from './base'

export default class DragRegular extends BaseAdapter implements DragAdapterInterface {
  private el: HTMLElement
  private mouseInElementPosition: Position

  constructor(el: HTMLElement) {
    super()
    this.el = el
  }

  public onMouseDown(event: any): Position {
    event = this.getEvent(event)
    this.setMouseInElementPosition(event)

    return this.getPosition(event)
  }

  public onMouseMove(event: any): Position {
    event = this.getEvent(event)
    const styleObject = new StyleObject(this.el)
    const position: Position = this.getPosition(event)

    styleObject.add('position', 'absolute')
    styleObject.add('pointer-events', 'none')
    styleObject.add('transform', `translate(${position.x}px, ${position.y}px)`)

    this.el.setAttribute('style', styleObject.toString())

    return position
  }

  public onMouseUp(event: any): Position {
    event = this.getEvent(event)
    const styleObject = new StyleObject(this.el)
    styleObject.remove('pointer-events')
    this.el.setAttribute('style', styleObject.toString())

    return this.getPosition(event)
  }

  private setMouseInElementPosition(event: any) {
    if (event.touches) {
      event = event.touches[0]
    }

    const elRect: ClientRect = this.el.getBoundingClientRect()

    this.mouseInElementPosition = {
      x: event.clientX - elRect.left,
      y: event.clientY - elRect.top,
    }
  }

  private getPosition(event: any): Position {
    if (!event) {
      return this.lastKnownPosition
    }

    const styleObject = new StyleObject(this.el)
    let x = event.clientX
    let y = event.clientY

    x -= this.mouseInElementPosition.x
    y -= this.mouseInElementPosition.y
    x = this.constrainToParentX(x, styleObject.getWidth() as number)
    y = this.constrainToParentY(y, styleObject.getHeight() as number)

    this.lastKnownPosition = { x, y }

    return this.lastKnownPosition
  }

  private constrainToParentX(x: number, width: number) {
    const parentRect = this.getParentClientRect()

    x = x - parentRect.left
    x = Math.max(x, 0)
    x = Math.min(x, parentRect.width - width)

    return x
  }

  private constrainToParentY(y: number, height: number) {
    const parentRect = this.getParentClientRect()

    y = y - parentRect.top
    y = Math.max(y, 0)
    y = Math.min(y, parentRect.height - height)

    return y
  }

  private getParentClientRect(): ClientRect {
    const elDragParent: HTMLElement = this.el.parentElement as HTMLElement
    const elDragParentRect: ClientRect = elDragParent.getBoundingClientRect()

    return elDragParentRect
  }
}
